import { type ApiResponseData, type ApiResponseDataParameters } from '@/common/types/http'
import axios, { type AxiosResponse, type AxiosError } from 'axios'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const isApiResponseData = (dataToken: any): dataToken is ApiResponseData => {
  return !!dataToken && typeof dataToken === 'object' && 'key' in dataToken
}

export const isApiError = (error: unknown): boolean => {
  if (axios.isAxiosError(error)) {
    return isApiResponseData(error.response?.data)
  }
  return false
}

export const getApiErrorResponse = (error: unknown): AxiosResponse<ApiResponseData> | undefined => {
  if (!isApiError(error)) throw new Error('Error is not an API error')
  return (error as AxiosError<ApiResponseData>).response
}

export const interpolateParameters = (message: string, parameters?: ApiResponseDataParameters): string =>
  (parameters ?? []).reduce((msg, { name, value }) => msg.replace(`{${name}}`, value), message)

export const getApiErrorTranslationParams = (apiError: ApiResponseData): [string, string[]] => [
  apiError.key,
  (apiError.parameters ?? []).sort((a, b) => Number(a.name) - Number(b.name)).map(({ value }) => value),
]
